var map = {
  "./": "45629",
  "./accordion": "77035",
  "./accordion.js": "77035",
  "./details": "59403",
  "./details.js": "59403",
  "./details_tab": "9223",
  "./details_tab.js": "9223",
  "./index": "45629",
  "./index.js": "45629",
  "./manage": "59814",
  "./manage.js": "59814",
  "./show": "82672",
  "./show.js": "82672"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 92463;
